import { render, staticRenderFns } from "./CreateProjectAssistant.vue?vue&type=template&id=7463b3f4&scoped=true&lang=pug&"
import script from "./CreateProjectAssistant.vue?vue&type=script&lang=ts&"
export * from "./CreateProjectAssistant.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7463b3f4",
  null
  
)

export default component.exports